import WeatherBox from "./components/WeatherBox";

function App() {
  return (
    <div className="App">
      <WeatherBox />
    </div>
  );
}

export default App;
